import React, { useEffect, useState } from 'react'
import { Autocomplete } from '@material-ui/lab'
import { TextField } from '@material-ui/core'
import { formatSwissDate } from 'components/globalDrawFunctions'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'

import './styles.scss'

import { Sparkline } from 'components/sparkline'
import { config } from './config'
import cantonNames from './cantonNames.js'

interface Props {
  canton: string
}

const daysBackFromNow = 30
export const Facts = ({ canton }: Props) => {
  const [cantonInternal, setCantonInternal] = React.useState(canton)
  const [factData, setFactData] = useState<dataForFacts | undefined>(undefined)
  const [dataBulk, setDataBulk] = useState(undefined)
  const [mapState, setMapState] = useState(false)
  const isMobile = config.isMobile

  useEffect(() => {
    console.log(canton)
    fetch(`./data/${canton.toLowerCase()}.json`)
      .then(response => {
        return response.json()
      })
      .then((data: CompCountryDataElement[]) => {
        setDataBulk(data)
      })
  }, [])

  useEffect(() => {
    if (dataBulk) setFactData(dataBulk)
  }, [dataBulk])

  useEffect(() => {
    if (dataBulk) setFactData(dataBulk)
  }, [cantonInternal])

  if (!factData) return null

  const date = new Date(factData.date).toLocaleDateString('ch-DE', {
    weekday: 'long',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
  })
  const newInfections = factData.lastNewCases
  const newDeath = factData.lastNewDeath
  const cases7DayAverage = factData.last7CasesAvg
  const cases7DayAverageChange = factData.change7CasesAvg + '% zum Vortag'
  const death7DayAverage = factData.last7DeathAvg
  const death7DayAverageChange = factData.change7DeathAvg + '% zum Vortag'
  const currentVent = factData.current_vent

  const cases7DaySum = factData.last7Cases
  const cases7DaySumChange = factData.change7Cases + '% zur Vorwoche'

  const death7DaySum = factData.last7Death
  const death7DaySumChange = factData.change7Death + '% zur Vorwoche'

  const doubling = factData.doubling + ' Tg.'
  const doublingChange = (
    <>
      {Math.abs(+factData.doublingChange)}%{' '}
      {+factData.doublingChange > 0 ? ' langsamer' : ' schneller'} als vor{' '}
      <span>einer Woche</span>{' '}
    </>
  )

  const newHosp = factData.all2WHosp[factData.all2WHosp.length - 1]
  const hospChange = factData.hospChange + '% zur Vorperiode'
  const SparklineNewInfections = <Sparkline values={factData.allDailyCases} />
  const SparklineNewDeath = <Sparkline values={factData.allDailyDeath} />

  const Sparkline7DDeath = (
    <Sparkline
      values={factData.allDailyDeath.slice(factData.allDailyDeath.length - 7)}
    />
  )

  const Sparkline7DayAveCases = (
    <Sparkline
      values={factData.all7DSumCaseAve.slice(
        factData.all7DSumCaseAve.length - daysBackFromNow
      )}
    />
  )
  const SparklineVent = (
    <Sparkline
      values={factData.allVent.slice(factData.allVent.length - daysBackFromNow)}
    />
  )
  const Sparkline7DayAveDeath = (
    <Sparkline
      values={factData.all7DSumDeathAve.slice(
        factData.all7DSumDeathAve.length - daysBackFromNow
      )}
    />
  )
  const Sparkline14DaySumCases = (
    <Sparkline
      values={factData.all14DSumCases.slice(
        factData.all14DSumCases.length - daysBackFromNow
      )}
    />
  )
  const Sparkline7DaySumCases = (
    <Sparkline
      values={factData.all7DSumCases.slice(
        factData.all7DSumCases.length - daysBackFromNow
      )}
    />
  )
  const SparklineInzidenz = (
    <Sparkline
      values={factData.allInzidenz.slice(
        factData.allInzidenz.length - daysBackFromNow
      )}
    />
  )
  const Sparkline7DaySumDeath = (
    <Sparkline
      values={factData.all7DSumDeath.slice(
        factData.all7DSumDeath.length - daysBackFromNow
      )}
    />
  )
  const SparklineDoubling = (
    <Sparkline
      values={factData.allDoubling.slice(
        factData.allDoubling.length - daysBackFromNow
      )}
      flipVertical
    />
  )
  const SparklineNewHosp = <Sparkline values={factData.all2WHosp} />

  const acValues = []
  for (const [key, value] of Object.entries(cantonNames)) {
    acValues.push({ id: key, value: value })
  }
  return (
    <div className='factContainer'>
      {factData && !isMobile && (
        <table>
          <tbody>
            <tr>
              <td className='title' colSpan={8}>
                <span>Situation in {cantonNames[canton]}</span>
                {/* <Autocomplete
                  className='autocomplete'
                  options={acValues}
                  getOptionLabel={o => o.value}
                  value={acValues.find(f => f.id === cantonInternal)}
                  onChange={(e, newValue) => setCantonInternal(newValue.id)}
                  renderInput={params => (
                    <TextField {...params} variant='outlined' />
                  )}
                  autoSelect
                  blurOnSelect
                  disableClearable
                  noOptionsText='Nichts gefunden'
                /> */}
              </td>
            </tr>

            <tr className='bb'>
              <td className='disclaimer' colSpan={8}>
                {/* Meldungen <strong>primär</strong> aus den Kantonen, können vom
                BAG abweichen. */}
              </td>
            </tr>
            <tr>
              <td className='subhead npt' colSpan={8}>
                {date}
              </td>
            </tr>

            <tr className='datekey'>
              <td />
              <td className='label' colSpan={1}>
                <span className='l'>1. Juni</span>
                <span className='r'>
                  {formatSwissDate(new Date(factData.date), 'middle')}
                </span>
              </td>
              <td colSpan={3} />
              <td className='label' colSpan={1}>
                <span className='l'>1. Juni</span>
                <span className='r'>
                  {formatSwissDate(new Date(factData.date), 'middle')}
                </span>
              </td>
              <td />
            </tr>
            <tr className=''>
              <td className='label'>Neuinfektionen</td>
              <td className='sparklineTd'>{SparklineNewInfections}</td>
              <td className='value'>
                <div className='cases'>{newInfections}</div>
              </td>
              <td className='spacer' />
              <td className='label'>Hospitalisiert</td>
              <td className='sparklineTd'>{SparklineNewHosp}</td>
              <td className='value'>
                <div className='hosp'>{newHosp}</div>
              </td>
            </tr>
            <tr>
              <td className='subhead' colSpan={6} />
            </tr>
            <tr className='datekey'>
              <td />
              <td className='label' colSpan={1}>
                <span className='l'>1. Juni</span>
                <span className='r'>
                  {formatSwissDate(new Date(factData.date), 'middle')}
                </span>
              </td>
              <td colSpan={3} />
              <td className='label' colSpan={1}>
                <span className='l'>1. Juni</span>
                <span className='r'>
                  {formatSwissDate(new Date(factData.date), 'middle')}
                </span>
              </td>
              <td />
            </tr>
            <tr>
              <td className='label'>Todesfälle</td>
              <td className='sparklineTd'>{SparklineNewDeath}</td>
              <td className='value'>
                <div className='death'>{newDeath}</div>
              </td>
              <td className='spacer' />
              <td className='label'>Beatmet</td>
              <td className='sparklineTd'>{SparklineVent}</td>
              <td className='value'>
                <div className='hosp'>{currentVent}</div>
              </td>
            </tr>

            <tr className='bb'>
              <td className='change' colSpan={3}>
                {/* {cases7DayAverageChange} */}
              </td>
              <td className='spacer' />
              <td className='change' colSpan={3}>
                {/* {death7DayAverageChange} */}
              </td>
            </tr>

            {/* SUMME 7 TAGE: AUSGEBLENDET UM INZIDENZEN PLATZ ZU MACHEN */}
            <tr>
              <td className='subhead' colSpan={6}>
                Summe der letzten 7 Tage
              </td>
            </tr>
            <tr>
              <td className='label'>Neuinfektionen</td>
              <td className='sparklineTd'>{Sparkline7DaySumCases}</td>
              <td className='value'>
                <div className='cases'>{factData.last7Cases}</div>
              </td>

              <td className='spacer' />
              <td className='label'>Todesfälle</td>
              <td className='sparklineTd'>{Sparkline7DDeath}</td>

              <td className='value'>
                <div className='death'>{death7DaySum}</div>
              </td>
            </tr>

            {/* <tr>
              <td className='subhead' colSpan={6}>
                14-Tages-Inzidenz
              </td>
            </tr>
            <tr>
              <td className='label'>Pro 100'000 Einwohner</td>
              <td className='sparklineTd'>{SparklineInzidenz}</td>
              <td className='value'>
                <div className='cases'>{factData.inzidenz}</div>
              </td>
              <td className='spacer' /> <td className='label'>Todesfälle</td>
              <td className='sparklineTd'>{Sparkline7DaySumDeath}</td>
              <td className='value'>
                <div className='death'>{death7DaySum}</div>
              </td>
            </tr> */}

            {/* <tr className='bb'>
              <td className='change' colSpan={3}>
                {cases7DaySumChange}
              </td>
              <td className='spacer' />
              <td className='change' colSpan={3}>
                {death7DaySumChange}
              </td>
            </tr>
            <tr>
              <td className='subhead la npb' colSpan={3}>
                Verdoppelungszeit
              </td>
              <td className='spacer' />
              <td className='subhead la npb' colSpan={3}>
              </td>
            </tr>
            <tr>
              <td className='label la npt' colSpan={3}>
              ...der Fälle der <span>2. Welle</span>
              </td>
              <td className='spacer' />
              <td className='label la npt' colSpan={3}>
              </td>
            </tr>
            <tr>
              <td className='label' />
              <td className='sparklineTd'>{SparklineDoubling}</td>
              <td className='value'>
                <div className='cases'>{doubling} </div>
              </td>

              <td className='spacer' />
              <td className='label'>Pro 100'000 Einwohner</td>
              <td className='sparklineTd'>{SparklineInzidenz}</td>
              <td className='value'>
                <div className='cases'>{factData.inzidenz}</div>
              </td>
            </tr>
            <tr>
              <td className='change' colSpan={3}>
                {doublingChange}
              </td>
              <td className='spacer' />
              <td className='change' colSpan={3}>
              </td>
            </tr> */}
          </tbody>
        </table>
      )}

      {factData && isMobile && (
        <table>
          <tbody>
            <tr>
              <td className='title' colSpan={6}>
                {/* Situation in der Schweiz */}

                <span>Situation in {cantonNames[canton]}</span>
                {/* <Autocomplete
                  className='autocomplete'
                  options={acValues}
                  getOptionLabel={o => o.value}
                  value={acValues.find(f => f.id === cantonInternal)}
                  onChange={(e, newValue) => setCantonInternal(newValue.id)}
                  renderInput={params => (
                    <TextField {...params} variant='outlined' />
                  )}
                  autoSelect
                  blurOnSelect
                  disableClearable
                  noOptionsText='Nichts gefunden'
                /> */}
              </td>
            </tr>

            <tr className='bb'>
              <td className='disclaimer' colSpan={6}>
                {/* Meldungen <strong>primär</strong> aus den Kantonen, können vom
                BAG abweichen. */}
              </td>
            </tr>

            <tr>
              <td className='subhead npt' colSpan={6}>
                {date}
              </td>
            </tr>
            <tr>
              <td className='label ca ' colSpan={2}>
                Neuinfektionen
              </td>
              <td className='spacer' />
              <td className='label ca' colSpan={2}>
                Hospitalisiert
              </td>
            </tr>

            <tr className=' datekey'>
              <td className='label' colSpan={1}>
                <span className='l'>1. Juni</span>
              </td>
              <td className='label' colSpan={2}>
                <span className='l'>
                  {formatSwissDate(new Date(factData.date), 'middle')}
                </span>
              </td>
              <td className='label' colSpan={1}>
                <span className='l'>1. Juni</span>
              </td>
              <td className='label' colSpan={1}>
                <span className='l'>
                  {formatSwissDate(new Date(factData.date), 'middle')}
                </span>
              </td>
            </tr>

            <tr className=''>
              <td className='sparklineTd'>{SparklineNewInfections}</td>
              <td className='value'>
                <div className='cases'>{newInfections}</div>
              </td>

              <td className='spacer' />
              <td className='sparklineTd'>{SparklineNewHosp}</td>
              <td className='value'>
                <div className='hosp'>{newHosp}</div>
              </td>
            </tr>

            <tr>
              <td className='label ca ' colSpan={2}>
                Todesfälle
              </td>
              <td className='spacer' />
              <td className='label ca' colSpan={2}>
                Beatmet
              </td>
            </tr>

            <tr className=' datekey'>
              <td className='label' colSpan={1}>
                <span className='l'>1. Juni</span>
              </td>
              <td className='label' colSpan={2}>
                <span className='l'>
                  {formatSwissDate(new Date(factData.date), 'middle')}
                </span>
              </td>
              <td className='label' colSpan={1}>
                <span className='l'>1. Juni</span>
              </td>
              <td className='label' colSpan={1}>
                <span className='l'>
                  {formatSwissDate(new Date(factData.date), 'middle')}
                </span>
              </td>
            </tr>

            <tr className='bb'>
              <td className='sparklineTd'>{SparklineNewDeath}</td>
              <td className='value'>
                <div className='death'>{newDeath}</div>
              </td>

              <td className='spacer' />
              <td className='sparklineTd'>{SparklineVent}</td>
              <td className='value'>
                <div className='hosp'>{currentVent}</div>
              </td>
            </tr>
            {/* 
            <tr>
              <td className='subhead' colSpan={6}>
                Durchschnitt der letzten 7 Tage
              </td>
            </tr>
            <tr>
              <td className='sparklineTd'>{Sparkline7DayAveCases}</td>
              <td className='value'>
                <div className='cases'>{cases7DayAverage}</div>
              </td>
              <td className='spacer' />
              <td className='sparklineTd'>{Sparkline7DayAveDeath}</td>
              <td className='value'>
                <div className='death'>{death7DayAverage}</div>
              </td>
            </tr>
            <tr className='bb'>
              <td className='change' colSpan={2}>
                {cases7DayAverageChange}
              </td>
              <td className='spacer' />
              <td className='change' colSpan={2}>
                {death7DayAverageChange}
              </td>
            </tr> */}
            <tr>
              <td className='subhead' colSpan={6}>
                Summe der letzten 7 Tage
              </td>
            </tr>

            <tr>
              <td className='label la npt' colSpan={2}>
                Neuinfektionen
              </td>
              <td className='spacer' />
              <td className='label la npt' colSpan={2}>
                Todesfälle
              </td>
            </tr>
            <tr>
              <td className='sparklineTd'>{Sparkline14DaySumCases}</td>
              <td className='value'>
                <div className='cases'>{factData.last7Cases}</div>
              </td>

              <td className='spacer' />
              <td className='sparklineTd'>{Sparkline7DDeath}</td>
              <td className='value'>
                <div className='death'>{death7DaySum}</div>
              </td>
              <td className='spacer' />
            </tr>

            {/* <tr className='bb'>
              <td className='change' colSpan={2}>
                {cases7DaySumChange}
              </td>
              <td className='spacer' />
              <td className='change' colSpan={2}>
                {death7DaySumChange}
              </td>
            </tr>
            <tr>
              <td className='subhead la npb' colSpan={2}>
                Verdoppelungszeit
              </td>
              <td className='spacer' />
              <td className='subhead la npb' colSpan={2}>
              </td>
            </tr>
            <tr>
              <td className='label la npt' colSpan={2}>
                ...der Fälle der <span>2. Welle</span>
              </td>
              <td className='spacer' />
              <td className='label la npt' colSpan={2}>
                Pro 100'000 Einwohner
              </td>
            </tr>
            <tr>
              <td className='sparklineTd'>{SparklineDoubling}</td>
              <td className='value'>
                <div className='cases'>{doubling}</div>
              </td>

              <td className='spacer' />
              <td className='sparklineTd'>{SparklineInzidenz}</td>
              <td className='value'>
                <div className='cases'>{factData.inzidenz}</div>
              </td>
            </tr>
            <tr>
              <td className='change' colSpan={2}>
                {doublingChange}
              </td>
              <td className='spacer' />
              <td className='change' colSpan={2}>
              </td>
            </tr> */}
          </tbody>
        </table>
      )}

      <div className='disclaimer_death'>
        Die Todesfälle weichen teilweise von anderen Publikationen ab. Diese Übersicht weist Todesfälle dann aus, wenn eine Person{' '}
        <b>verstorben</b> ist. Der Tageswert ist daher oft zu tief, da aktuelle
        Todesfälle erst in den nächsten Tagen gemeldet werden. Der Kanton
        hingegen vermeldet Todesfälle an dem Tag, an dem die Meldung bei den
        Behörden <b>eingetroffen</b> ist.
      </div>
      <div className='mapWrapper' style={{ height: mapState ? 'auto' : '0px' }}>
        <AutofitIFrame
          src='https://datawrapper.dwcdn.net/NZPTj/'
          height='250px'
        />
      </div>
      <div className='mapbuttonWrapper'>
        <div className='mapbutton'>
          <i
            className='ui text icon chevron right'
            onClick={() => setMapState(!mapState)}
          >
            <span>
              Auslastung Spitäler {mapState ? 'einklappen' : 'ausklappen'}
            </span>
          </i>
        </div>
      </div>
    </div>
  )
}
